module.exports = __webpack_public_path__ + "a336747e50d804563e994620f37c39a1.fbx";